/** @type {import("@mui/material").SxProps<Theme>} */

const styles = theme => ({
  cartIcon: {
    display: 'flex',
    justifyContent: 'center',
  },
  buttonContainer: {
    justifyContent: 'center',
    display: 'flex',
    p: 2,
  },
  emptyCartButton: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    borderRadius: '6.25rem',
    width: '8.125rem',
    padding: '0.3125rem',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,

    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 2px 4px -1px ${theme.palette.primary.boxShadow}, 0px 4px 5px  ${theme.palette.primary.boxShadow}, 0px 1px 10px  ${theme.palette.primary.boxShadow}`,
    },
  },
});

export default styles;
